// Resolución y precarga de las capturas de la pantalla de Novedades.
//
// Lo usan tanto `aVersionScreenshot.vue` (para pintar) como `Version.vue`
// (para precargar), de modo que las dos piden exactamente las mismas URLs y
// la precarga sirve de verdad.

import releases, { CURRENT_VERSION } from "@/constants/releases.js";
import { customer } from "@/params.js";

/**
 * URLs candidatas para una captura, de más a menos específica:
 *   1. miniatura del customer   2. miniatura genérica
 *   3. png del customer         4. png genérico
 *
 * `variants` es la lista de customers que tienen captura propia de esa
 * pantalla. Sólo probamos la carpeta del customer si está declarada ahí: si
 * no, cada imagen gastaría un 404 antes de caer a la genérica.
 */
export function candidates(version, image, variants) {
  if (!image) return [];
  const base = "/img/versions/" + version + "/";
  const dir =
    variants && customer && variants.indexOf(customer) >= 0
      ? customer + "/"
      : null;
  const list = [];
  if (dir) list.push(base + dir + image + "-thumb.jpg");
  list.push(base + image + "-thumb.jpg");
  if (dir) list.push(base + dir + image + ".png");
  list.push(base + image + ".png");
  return list;
}

/**
 * Calienta la caché del navegador con las miniaturas de un release.
 *
 * Las tarjetas no se pintan hasta que la API devuelve hoteles y permisos
 * (~2-3 s), así que sin esto las imágenes ni siquiera empezarían a bajarse
 * hasta entonces. Lanzándolas aquí viajan en paralelo con la API y cuando el
 * componente monta ya están en caché.
 */
export function prefetch(release) {
  if (!release || typeof Image === "undefined") return 0;

  const shots = [];
  if (release.cover) shots.push({ image: release.cover, variants: null });
  (release.features || []).forEach(f => {
    if (f.image) shots.push({ image: f.image, variants: f.variants });
  });

  let started = 0;
  shots.forEach(shot => {
    const list = candidates(release.version, shot.image, shot.variants);
    if (!list.length) return;
    const img = new Image();
    // Si el customer no tiene su propia versión, caemos a la genérica igual
    // que hace el componente al pintar.
    img.onerror = () => {
      if (list[1]) {
        const fallback = new Image();
        fallback.src = list[1];
      }
    };
    img.src = list[0];
    started++;
  });
  return started;
}

/** Precarga las capturas de la versión que se está publicando. */
export function prefetchCurrentRelease() {
  return prefetch(releases.find(r => r.version === CURRENT_VERSION));
}
